if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // 从表单中提取数据
        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        // 构建 JSON 请求体
        const requestBody = {
          items: [{
            id: variantId,
            quantity: parseInt(quantity, 10)
          }]
        };

        // 添加选中的服务信息
        const STORAGE_PREFIX = 'assembly_service_';
        const storedSelection = window.sessionStorage.getItem(STORAGE_PREFIX + variantId);
        let assemblySelection = null;

        if (storedSelection) {
          try {
            assemblySelection = JSON.parse(storedSelection);
          } catch (e) {
            if (/^\d+$/.test(String(storedSelection))) {
              assemblySelection = { variantId: String(storedSelection) };
            }
          }
        }

        const assemblyServiceId = assemblySelection?.variantId;
        if (assemblyServiceId) {
          requestBody.items.push({
            id: assemblyServiceId,
            quantity: parseInt(quantity, 10)
          });
        }

        if (variantId && assemblyServiceId) {
          requestBody.items[0].properties = {
            _assembly_service: assemblyServiceId,
            _service_provider: assemblySelection.providerCode || '',
            _service_offering: assemblySelection.offeringCode || '',
            _service_offering_name: assemblySelection.offeringName || '',
          };
        }

        // 如果存在购物车，添加 sections 信息
        if (this.cart) {
          const sectionsToRender = this.cart.getSectionsToRender();
          // Shopify /cart/add.js 期望 sections 为字符串数组
          requestBody.sections = sectionsToRender.map((section) => section.id || section.section || section);
          requestBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        // 配置 fetch 请求
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(requestBody)
        };

        fetch('/cart/add.js', config)
          .then((response) => {
            if (!response.ok) {
              return response.json().then(errorData => {
                throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
              });
            }
            return response.json();
          })
          .then((response) => {

            // Shopify /cart/add.js 返回错误时会有 status 字段
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // A service variant can become unavailable after the page has loaded.
              // Keep the main product button usable so the customer can change the service and retry.
              if (assemblyServiceId) {
                this.error = false;
                return;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                const defaultItem = response.items.find((item) => {
                  if (String(item.id) !== String(variantId)) return false;

                  const itemAssemblyServiceId = item.properties?._assembly_service;
                  return assemblyServiceId
                    ? String(itemAssemblyServiceId) === String(assemblyServiceId)
                    : !itemAssemblyServiceId;
                }) || response.items.find(item => item.requires_shipping) || response.items[0];
                console.log('response', response)
                this.cart.renderContents({...response, key: defaultItem.key});
              }
            }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
